import { render } from "./modal.vue?vue&type=template&id=288dd446"
import script from "./modal.vue?vue&type=script&lang=js"
export * from "./modal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/components/modal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "288dd446"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('288dd446', __exports__)) {
    console.log('reload')
    api.reload('288dd446', __exports__)
  }
  
  module.hot.accept("./modal.vue?vue&type=template&id=288dd446", () => {
    console.log('re-render')
    api.rerender('288dd446', render)
  })

}


export default __exports__